import './src/fonts/typography.css'
import './src/components/layout.css'

import gsap from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(CustomEase)
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

CustomEase.create('camCustom', '0.72, 0, 0.12, 1')
CustomEase.create('camCustomOut', '0.12, 1, 0.72, 1')
